import { idenityI18nKeys } from '../identity-i18n-keys';
export const zh = {
    "UserName": "用户名",
    "Password": "密码",
    "RoleCode": "角色代码",
    "RoleName": "角色名称",
    "Operation": "操作",
    "AddRole": "创建角色",
    "EditRole": "编辑角色",
    "Search": "查询",
    "Reset": "重置",
    "Required": "请输入{0}",
    "Login": "登录",
    "Register": "注册",
    "ForgotPassword": "忘记密码",
    "Permissions": "权限"
}